import React, { useEffect, useState } from 'react';
import getCreditAppeal from '../../api/deals/getCreditAppeal';
import { ApplicationSkeleton } from './CreditSkeletons';
import formatNumber from '../../utils/formatNumber';

const MARITAL_STATUS_LABELS = {
  0: 'Не указано',
  1: 'Не в браке',
  2: 'В браке',
  3: 'Вдовец / вдова',
  4: 'Гражданский брак',
  5: 'В разводе',
};

const DOCUMENT_ISSUER_LABELS = {
  MINISTRY_OF_THE_INTERIOR: 'МВД',
  MINISTRY_OF_JUSTICE: 'Минюст',
};

const Field = ({ label, value }) => {
  if (value === undefined || value === null || value === '') return null;
  return (
    <div>
      <p style={{ color: '#6A6A6A', fontSize: 12, lineHeight: '16px', marginBottom: 4 }}>{label}</p>
      <p style={{ fontSize: 14, lineHeight: '20px', wordBreak: 'break-word' }}>{value}</p>
    </div>
  );
};

/**
 * Что клиент указал в самой заявке на кредит (доход, работа, семейное положение
 * и т.д.) — данные одни на всю заявку, банк не важен, поэтому берём JSON первой
 * попавшейся заявки чанка (createCreditAppealRequest, CreditApplication.json).
 */
const LeadCreditApplicationDetails = ({ chunkId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!chunkId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    getCreditAppeal({ chunkId })
      .then((res) => {
        const raw = res.data?.appeals?.[0]?.json;
        if (raw) {
          try {
            setData(JSON.parse(raw));
          } catch {
            setData(null);
          }
        }
      })
      .finally(() => setLoading(false));
  }, [chunkId]);

  if (loading) return <ApplicationSkeleton />;
  if (!data) return <p style={{ color: '#6A6A6A', fontSize: 14 }}>Данных заявки нет.</p>;

  const contactPersons = data.contactPersons?.filter((p) => p?.contactPersonLastName) || [];

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px 24px' }}>
        <Field label="Первоначальный взнос" value={data.initialFee ? formatNumber(data.initialFee) : null} />
        <Field label="Срок кредита" value={data.period ? `${data.period} мес.` : null} />
        <Field label="Доход" value={data.incomeMain ? formatNumber(data.incomeMain) : null} />
        <Field label="Доп. доход" value={data.additionalIncome ? formatNumber(data.additionalIncome) : null} />
        <Field label="Место работы" value={data.workName} />
        <Field label="Адрес работы" value={data.workAddress} />
        <Field label="Статус занятости" value={data.workStatus} />
        <Field label="Телефон работодателя" value={data.companyPhone} />
        <Field label="Семейное положение" value={MARITAL_STATUS_LABELS[data.MaritalStatus]} />
        <Field label="Дети" value={data.childrensCount} />
        <Field label="Резидент РК" value={data.residentBool === 1 ? 'Да' : data.residentBool === 0 ? 'Нет' : null} />
        <Field label="Кем выдан документ" value={DOCUMENT_ISSUER_LABELS[data.documentGivedBy]} />
      </div>

      {contactPersons.length > 0 && (
        <div style={{ marginTop: 24, paddingTop: 20, borderTop: '1px solid #E7E7ED' }}>
          <p style={{ color: '#6A6A6A', fontSize: 12, lineHeight: '16px', marginBottom: 8 }}>Контактные лица</p>
          {contactPersons.map((p, i) => (
            <p key={i} style={{ fontSize: 14, lineHeight: '22px' }}>
              {p.contactPersonFirstName} {p.contactPersonLastName} — {p.contactPersonPhone}
              {p.contactPersonType ? ` (${p.contactPersonType})` : ''}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default LeadCreditApplicationDetails;
